// @TS-nocheck
import React from 'react'
import { logger, validateAxiosResponse } from '@dmi-mch/utils'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import classNames from 'classnames'
import { Container, Row, Col } from '@mch-group/uikit-components'

import Title from '@reusable-modules/HeadlineTitle'
import CallToAction from '@reusable-modules/common/CallToAction'
import { mq, px2rem, hiDPIpx } from '@utils'
import { Events as EventsService, Gallery as GalleriesService } from '@services'
import cssClasses from '@constants/cssClasses'
import EventCardList from '@components/ot-modules/Events/components/EventCardList'

const { useEffect, useState } = React

const mID = 'otm-preview-events'

const EventsPreview = (props) => {
  const autoDetect = props.grcpm_auto_detect_gallery === 'true'
  const galleryId = autoDetect ? props.pageMetaInfo.id : props.grcpm_related_gallery
  const [eventsList, setEventsList] = useState([])

  useEffect(() => {
    let isUnmounted = false
    async function fetchData() {
      try {
        // Get the owner account id with an API call if the module has not been set up to auto-detect the
        // exhibitor in CMS.
        // Otherwise, get the owner account id info from the props directly.
        let ownerAccountId = null
        if (autoDetect) {
          ownerAccountId = window.location.href.includes('/catalog/gallery')
            ? props.pageMetaInfo.accountId
            : props.pageMetaInfo.ownerAccountId
        } else {
          const galleryResponse = await GalleriesService.getGalleryById(galleryId)
          if (validateAxiosResponse(galleryResponse) && !isUnmounted) {
            ownerAccountId = galleryResponse.data.accountId
          }
        }

        // based on the preview module type (i.e. preview events, preview exhibitions, preview events & exhibitions)
        // we should pass the "exhibition" param accordingly
        const upcomingParams = {
          offset: 0,
          limit: 4,
          includeFilters: false,
          withAnOwnerAccountId: true,
          ownedOrRelatedToAccount: ownerAccountId,
          orderBy: 'endDate ASC',
          online: false
        }
        if (props.type === 'events') {
          upcomingParams.exhibition = false
        } else if (props.type === 'exhibitions') {
          upcomingParams.exhibition = true
        }
        const req = await EventsService.getUpcomingEvents(upcomingParams)

        // ok
        if (validateAxiosResponse(req) && !isUnmounted) {
          setEventsList(req.data.events.items)
        }
      } catch (e) {
        logger(e)
      }
    }
    fetchData()

    return () => {
      isUnmounted = true
    }
  }, [autoDetect, galleryId, props.pageMetaInfo.accountId, props.pageMetaInfo.ownerAccountId, props.type])

  if (eventsList && eventsList.length > 0) {
    return (
      <section
        id={props.id}
        className={classNames(
          mID,
          props.className,
          cssClasses.CMS_MODULE,
          props.grcpm_bg_color === 'bg_grey' ? 'bg_grey' : ''
        )}
      >
        <Title hch-grp1_title_style='title_style_2' hch-grp1_header={props.grcpm_title} />
        <Container className='px-5 px-lg-8 px-md-7 mt-0'>
          {eventsList.length ? (
            <Row>
              {eventsList.map((event, i) => (
                <Col key={event?.id} xs={12} sm={12} md={4} lg={4} xl={3} xxl={3} className='mb-lg-8 mb-md-8 d-flex'>
                  <EventCardList index={i} item={event} isCollectionCard={false} />
                </Col>
              ))}
            </Row>
          ) : null}
          <Container padded='vertically'>
            {props.grcpm_call_to_action_label && (
              <Row>
                <Col>
                  {props.grcpm_call_to_action_link ? (
                    <CallToActionStyled href={props.grcpm_call_to_action_link} hrefAs={props.grcpm_call_to_action_link}>
                      {props.grcpm_call_to_action_label}
                    </CallToActionStyled>
                  ) : (
                    <CallToActionStyled>
                      <a href='#events'>{props.grcpm_call_to_action_label}</a>
                    </CallToActionStyled>
                  )}
                </Col>
              </Row>
            )}
          </Container>
        </Container>
      </section>
    )
  }
  return null
}

EventsPreview.propTypes = {
  className: PropTypes.string,
  grcpm_auto_detect_gallery: PropTypes.string,
  pageMetaInfo: PropTypes.object,
  grcpm_title: PropTypes.string,
  grcpm_call_to_action_label: PropTypes.string,
  grcpm_call_to_action_link: PropTypes.string,
  grcpm_related_gallery: PropTypes.string,
  id: PropTypes.number,
  type: PropTypes.string,
  grcpm_bg_color: PropTypes.string
}

const CallToActionStyled = styled(CallToAction)`
  margin-top: ${px2rem(40)};
`

export default styled(EventsPreview)`
  position: relative;

  @media (max-width: 992px) {
    .image-frame > button {
      display: none;
    }
  }

  &.bg_grey {
    background: var(--bs-mch-galleries);
    margin-bottom: 0 !important;
    padding-bottom: ${px2rem(45)};
    ${mq.between('tablet', 'largestTablet')`
      padding-bottom: ${hiDPIpx(5)};
    `}
    ${mq.lessThan('largestMobile')`
      padding-bottom: ${px2rem(5)};
    `}
    h3:not(.title.truncate) {
      padding-top: ${px2rem(36)};
    }
  }

  &&& {
    .${mID}__list {
      padding-top: 0 !important;

      .${mID}__column:not(:first-child) {
        ${mq.lessThan('largestTablet')`
          margin-top: ${px2rem(40)};
        `}
      }
    }
  }
`
